import React, { useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

// d.ts
import { DCRecord, IDataController } from "@/@types/lib/dataController"

// Custom Components
import ModelTable from "@/ui/Table/ModelTable";
import DialogContext from "@/ui/DialogContext/DialogContext";
import UserDialog from "./UserDialog";

import model from "@/models/user";
import dataController from "@/lib/dataController";
import { DialogContextType } from "@/@types/ui/DialogContext";
import { useNavigate } from "react-router";

function UsersTable() {
  const dialogContext = useContext<DialogContextType>(DialogContext);
  const { t } = useTranslation();

  const [records, setRecords] = useState<DCRecord[]>([]);

  const dc: IDataController = new dataController(model);
  const navigate = useNavigate()

  useEffect(() => {
    refreshRecords();
  }, []);

  const handleAdd = () => {
    dialogContext.showDialog(UserDialog, {
      dc: dc,
      mode: "insert",
      form: "insert",
      onClose: handleDialogClose
    });
  };

  const handleDialogClose = (result: { dataChanged: boolean; action: string }) => {
    if (result.dataChanged) {
      refreshRecords();
    }
    dialogContext.hideDialog()
  };

  const refreshRecords = () => {
    dc.GetData().then((resp) => {
      if (resp.success) {
        setRecords(resp.data as Array<DCRecord>)
      };
    });
  };


  return (
    <ModelTable
      title={t("titles.users")}
      records={records}
      dc={dc}
      allowSelection={'none'}
      allowFilter={true}
      allowExport={true}
      allowEdit={true}
      allowDelete={true}
      onDeleted={() => refreshRecords()}
      onEdit={(recordId: number) => navigate('/user/' + recordId)}
      allowAdd={true}
      addLabel={t("buttons.new_m")}
      handleAdd={handleAdd}
      onRowAction={() => { }}
      allowRowAction={() => { return true; }}
    />
  );
}

export default UsersTable;
